import { equals } from 'ramda';

import { APPLICATION_CONTENT_VIEWS } from '@framework/constants/enums';

import { GENERAL_RESOLUTION_CHANGE, GENERAL_COPY, GENERAL_PASTE } from './constants/insights';
import { debounce } from './utils';

export const isAdminPortal = equals(APPLICATION_CONTENT_VIEWS.ADMIN_PORTAL);
export const isEditor = equals(APPLICATION_CONTENT_VIEWS.EDITOR);

export const isAttendeeView = equals(APPLICATION_CONTENT_VIEWS.ATTENDEE);

// returns a function that stops reporting

export const startReportingWindowSize = (sendInsight) => {
    const handleResize = debounce(() => {
        sendInsight(GENERAL_RESOLUTION_CHANGE, {
            newResolution: [window.innerWidth, window.innerHeight]
        });
    }, 3000);

    window.addEventListener('resize', handleResize);
    return () => {
        window.removeEventListener('resize', handleResize);
    };
};

export const startReportingCopy = (target, sendInsight, data = {}) => {
    const handleCopy = () => {
        sendInsight(GENERAL_COPY, data);
    };

    target.addEventListener('copy', handleCopy);
    return () => {
        target.removeEventListener('copy', handleCopy);
    };
};

export const startReportingPaste = (target, sendInsight, data = {}) => {
    const handlePaste = () => {
        sendInsight(GENERAL_PASTE, data);
    };

    target.addEventListener('paste', handlePaste);
    return () => {
        target.removeEventListener('paste', handlePaste);
    };
};
